<template>
    <div class="header displayFlex">
        <div class="left displayFlex">
            <!-- logo -->
            <img class="logo cursor" :style="logoUrl ? '' : 'border: 1px solid #e5e5e5;'" :src="logoUrl"
                @click="onIndexClick" alt="LOGO" />
            <!-- <img class="logo-right" src="@/assets/image/index/logo20250826.png" alt=""> --> 
        </div>
        <!-- 右侧 -->
        <div class="dgjdds">
            <div class="left">
                全国服务热线：400-829-617
            </div>
            <div class="right">
                <div v-if="isIndex" class="enter displayFlex disabledCopy cursor">
                    <router-link to="/merchants" exact class="btn disabledCopy">供应商入驻</router-link>
                    <router-link to="/school" exact class="btn disabledCopy">单位入驻</router-link>
                </div>
                <!-- 定位/选择位置 el-icon-location-outline -->
                <!-- <div class="location">
                <div class="textRoll">
                    <marquee class="marquee" behavior="scroll" @onMouseOut="this.start()" @onMouseOver="this.stop()">
                        {{ areaName }}
                    </marquee>
                </div>
                <el-cascader class="cascader disabledCopy cursor" placeholder="请选择省市区" v-model="addressVal"
                    :options="cityDataArr" @expand-change="handleChange" @change="handleChange" :props="{
                        value: 'id',
                        label: 'regionName',
                        children: 'cities'
                    }"></el-cascader>
                <i class="el-icon-location-outline icon"></i>
            </div> -->
                <!-- 配送网链接 -->
                <div class="delivery-link displayFlex disabledCopy cursor" @click="onDeliveryClick">
                    <img class="delivery-img" src="@/assets/image/index/kuaidi.png" alt="配送">
                    <div class="text">配送网</div>
                </div>
                <div class="shuxian"></div>
                <!-- 举报 -->
                <div class="tip_off displayFlex disabledCopy cursor" @click="onClickTips">
                    <img class="tip_img" :src="tip_img" alt="举报">
                    <div class="text">举报</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qr_code from '@/assets/image/index/qr_code.png'
import tip_img from '@/assets/image/index/icon_jubao.png'
export default {
    name: '',
    props: {
        logoUrl: { // title
            type: String,
            default: ''
        },
    },
    data() {
        return {
            qr_code,
            tip_img,
            isIndex: false, // 是否首页
            // value: ["440000", "440900", "440904"], // 默认值
            cityDataArr: ['440000', '440900', '440904'], // 省市区级联列表
            provinceId: "", // 省id
            cityId: "", // 市id
            areaId: "", // 区id
            addressVal: [], // 选中的地址code集
            areaName: '广东省/茂名市/电白区', // 选中的地址名称
            // singleVal: '440904', // 选中项
            singleValList: [
                {
                    value: '440902',
                    label: '广东省 茂名市 茂南区',
                    // disabled: true
                },
                {
                    value: '440904',
                    label: '广东省 茂名市 电白区'
                },
                {
                    value: '440981',
                    label: '广东省 茂名市 高州市',
                    // disabled: true
                },
                {
                    value: '440982',
                    label: '广东省 茂名市 化州市',
                    // disabled: true
                },
                {
                    value: '440983',
                    label: '广东省 茂名市 信宜市',
                    // disabled: true
                },
            ]
        }
    },
    components: {},
    created() {
        this.getNodes();
    },
    watch: {
        $route: function (newVal, oldVal) {
            let { name, path } = newVal
            if (name == 'Merchants' || name == 'School' || path == '/merchants' || path == '/school') {
                this.isIndex = true
            } else {
                this.isIndex = false
            }
        }
    },
    methods: {
        // 单项下拉选择
        // singleChange(value) {
        //     console.log('单项下拉选择', value, typeof value, value != '440904' ? '1':'1111');
        //     if (value != '440904') {
        //         return false
        //     }
        //     this.singleVal = value
        // },
        // 点击logo、网站名称跳回首页
        onIndexClick() {
            this.$router.push("/");
        },
        // 点击举报
        onClickTips() {
            // this.$message({
            //     message: '模块暂未开放',
            //     type: "warning",
            //     center: true
            // });
            this.$router.push({ path: "/complaint", query: { index: 10 } });
        },
        // 级联位置/单位选择
        handleChange(val) {
            this.getNodes(val);
            this.provinceId = val[0];
            this.cityId = val[1];
            this.areaId = val[2];
            this.getAreaName(val)
            console.log("级联位置/单位选择1", val);
        },
        // 筛选名称
        getAreaName(val) {
            let str = ''
            this.cityDataArr.forEach((itm, idx) => {
                if (itm.id == val[0]) {
                    str = itm.regionName + '/'
                    itm.cities.forEach((itc, idc) => {
                        if (itc.id == val[1]) {
                            str += itc.regionName + '/'
                            itc.cities.forEach((ita, ida) => {
                                if (ita.id == val[2]) {
                                    str += ita.regionName
                                }
                            })
                        }
                    })
                }
            })
            this.areaName = str
            console.log('this.areaName', this.areaName)
        },
        // 获取省市区数据
        getNodes(val) {
            let idArea;
            let sizeArea;
            if (!val) {
                idArea = null;
                sizeArea = 0;
                this.$get(this.$api.getProvince).then(res => {
                    let Items = res.data;
                    this.cityDataArr = Items.map((value, i) => {
                        return {
                            id: value.id,
                            regionName: value.regionName,
                            cities: []
                        };
                    });
                });
            } else if (val.length === 1) {
                idArea = val[0];
                sizeArea = val.length;
                this.cityDataArr.map((value, i) => {
                    if (value.id === val[0]) {
                        this.$get(this.$api.getCity + val[0]).then(res => {
                            let Items = res.data;
                            value.cities = Items.map((item, i) => {
                                return {
                                    id: item.id,
                                    regionName: item.regionName,
                                    cities: []
                                };
                            });
                        });
                    }
                });
            } else if (val.length === 2) {
                idArea = val[1];
                sizeArea = val.length;
                this.cityDataArr.map((value, i) => {
                    if (value.id === val[0]) {
                        value.cities.map((itec, i) => {
                            if (itec.id === val[1]) {
                                if (!itec.cities.length) {
                                    this.$get(this.$api.getArea + val[1]).then(
                                        res => {
                                            let Items = res.data;
                                            if (Items) {
                                                itec.cities = Items.map(
                                                    (every, i) => {
                                                        return {
                                                            id: every.id,
                                                            regionName:
                                                                every.regionName
                                                        };
                                                    }
                                                );
                                            }
                                        }
                                    );
                                }
                            }
                        });
                    }
                });
            }
        },
        // 点击配送网
        onDeliveryClick() {
            window.open('https://www.liancanps.com/', '_blank');
        },
    }
}
</script>

<style lang='less' scoped>
.shuxian {
    border-left: 1px solid #184BB0;
    .wh(0, 28px);
    margin: 0 18px;
}

.displayFlex {
    display: flex;
    align-items: center;
}

.header {
    justify-content: space-between;
    .wh(1380px, 107px);
    margin: 0 auto;
    position: relative;

    .logo {
        display: block;
        .wh(340px, 200px);
        object-fit: contain;
        margin-left: -15px;

        // .wh(737px, 72px);
        // background: url(../../assets/image/index/logo3.png) no-repeat;

        // .wh(60px, 70px);
        // margin-right: 20px;
    }

    .logo-right {
        position: absolute;
        top: 0;
        left: 0;
        .wh(250px, 80%);
        padding-left: 0;
        margin-left: 35px;
        -o-object-fit: contain;
        object-fit: contain;
        background-color: #FFF;
        padding-right: 30px;
        padding-bottom: 10px;
        padding-top: 10px;
    }

    .line {
        .wh(1px, 40px);
        background: #1d57bd;
        margin: 0 12px 0;
    }

    .title {
        font-size: 38px;
        font-weight: normal;
        color: #1d57bd;
    }

    .dgjdds {
        display: flex;
        align-items: center;

        .left {
            .font(16px, #FF0000);
            margin-right: 150px;
            font-weight: bold;
        }

        .right {
            display: flex;
            align-items: center;
        }

        .qr_code {
            .wh(100px, 100px);
            margin-right: 28px;
        }

        .enter {
            flex-direction: column;
            margin-right: 40px;

            .btn {
                width: 116px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                font-size: 16px;
                color: #1d57bd;
                background: #eff5ff;
                border: 1px solid #1d57bd;
                border-radius: 4px;

                &:hover {
                    color: #4e84e2;
                    border: 1px solid #6294e9;
                }

                &:first-child {
                    margin-bottom: 12px;
                }
            }
        }

        .tip_off {
            right: 265px;

            .tip_img {
                .wh(32px, 26px);
                margin-right: 10px;
            }

            .text {
                .font(17px, #1d57bd);
                font-weight: bold;
            }
        }

        .location {
            position: relative;
            margin-right: 20px;
            color: #184bb0;

            .textRoll {
                position: absolute;
                width: 100%;
                height: 100%;
                color: #184bb0;
                border: 1px solid #184bb0;
                border-radius: 5px;
                overflow: hidden;
                padding: 0 28px;
                box-sizing: border-box;

                .marquee {
                    display: flex;
                    align-items: center;
                    height: 100%;
                }
            }

            .icon {
                position: absolute;
                top: 6px;
                left: 5px;
                font-size: 28px;
            }

            /deep/.el-input--suffix .el-input__inner {
                opacity: 0;
                // color: #184bb0;
                // border: 1px solid #184bb0;
                // padding-left: 35px;
            }

            /deep/.el-select .el-input .el-select__caret {
                color: #184bb0;
                font-weight: bold;
            }
        }

        .delivery-link {
            right: 380px;

            .delivery-img {
                .wh(40px, 34px);
                margin-right: 10px;
            }

            .text {
                .font(17px, #1d57bd);
                font-weight: bold;
            }
        }

        .shuxian {
            &:nth-of-type(1) {
                right: 470px;
            }

            &:nth-of-type(2) {
                right: 362px;
            }
        }
    }
}
</style>
<style>
.popper_class .el-select-dropdown__item {
    color: #4e84e2;
}
</style>



// WEBPACK FOOTER //
// src/components/indexModule/header.vue